/* tslint:disable */
/* eslint-disable */
/**
 * Risks API
 * API for managing risks.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LoanTierDto } from './LoanTierDto';
import {
    LoanTierDtoFromJSON,
    LoanTierDtoFromJSONTyped,
    LoanTierDtoToJSON,
    LoanTierDtoToJSONTyped,
} from './LoanTierDto';

/**
 * DTO pour la lecture des informations générales d'un prêt
 * @export
 * @interface LoanInfosDto
 */
export interface LoanInfosDto {
    /**
     * 
     * @type {string}
     * @memberof LoanInfosDto
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof LoanInfosDto
     */
    loanAmount: number;
    /**
     * 
     * @type {number}
     * @memberof LoanInfosDto
     */
    totalDuration: number;
    /**
     * 
     * @type {string}
     * @memberof LoanInfosDto
     */
    interestRateTypeId: string;
    /**
     * 
     * @type {number}
     * @memberof LoanInfosDto
     */
    interestRatePercentage: number;
    /**
     * 
     * @type {string}
     * @memberof LoanInfosDto
     */
    defermentTypeId: string;
    /**
     * 
     * @type {number}
     * @memberof LoanInfosDto
     */
    defermentPeriod: number;
    /**
     * 
     * @type {string}
     * @memberof LoanInfosDto
     */
    loanTypeId: string;
    /**
     * 
     * @type {number}
     * @memberof LoanInfosDto
     */
    insuranceAmount?: number;
    /**
     * 
     * @type {Array<LoanTierDto>}
     * @memberof LoanInfosDto
     */
    tiers?: Array<LoanTierDto>;
}

/**
 * Check if a given object implements the LoanInfosDto interface.
 */
export function instanceOfLoanInfosDto(value: object): value is LoanInfosDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('loanAmount' in value) || value['loanAmount'] === undefined) return false;
    if (!('totalDuration' in value) || value['totalDuration'] === undefined) return false;
    if (!('interestRateTypeId' in value) || value['interestRateTypeId'] === undefined) return false;
    if (!('interestRatePercentage' in value) || value['interestRatePercentage'] === undefined) return false;
    if (!('defermentTypeId' in value) || value['defermentTypeId'] === undefined) return false;
    if (!('defermentPeriod' in value) || value['defermentPeriod'] === undefined) return false;
    if (!('loanTypeId' in value) || value['loanTypeId'] === undefined) return false;
    return true;
}

export function LoanInfosDtoFromJSON(json: any): LoanInfosDto {
    return LoanInfosDtoFromJSONTyped(json, false);
}

export function LoanInfosDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): LoanInfosDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'loanAmount': json['loanAmount'],
        'totalDuration': json['totalDuration'],
        'interestRateTypeId': json['interestRateTypeId'],
        'interestRatePercentage': json['interestRatePercentage'],
        'defermentTypeId': json['defermentTypeId'],
        'defermentPeriod': json['defermentPeriod'],
        'loanTypeId': json['loanTypeId'],
        'insuranceAmount': json['insuranceAmount'] == null ? undefined : json['insuranceAmount'],
        'tiers': json['tiers'] == null ? undefined : ((json['tiers'] as Array<any>).map(LoanTierDtoFromJSON)),
    };
}

export function LoanInfosDtoToJSON(json: any): LoanInfosDto {
    return LoanInfosDtoToJSONTyped(json, false);
}

export function LoanInfosDtoToJSONTyped(value?: LoanInfosDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'loanAmount': value['loanAmount'],
        'totalDuration': value['totalDuration'],
        'interestRateTypeId': value['interestRateTypeId'],
        'interestRatePercentage': value['interestRatePercentage'],
        'defermentTypeId': value['defermentTypeId'],
        'defermentPeriod': value['defermentPeriod'],
        'loanTypeId': value['loanTypeId'],
        'insuranceAmount': value['insuranceAmount'],
        'tiers': value['tiers'] == null ? undefined : ((value['tiers'] as Array<any>).map(LoanTierDtoToJSON)),
    };
}

